import { Directive } from '@angular/core';

export const TIPPY_ITEM_CLASS: string = 'tippy-item';

@Directive({
  selector: '[portalTippyItem]',
  host: {
    class: TIPPY_ITEM_CLASS,
  },
  standalone: false,
})
export class TippyItemDirective {}
